export class TableReport
{
    b_date?:any;
    cash_amount?:number;
    card_amount?:number;
    cheque_amount?:number;
}



// WEBPACK FOOTER //
// ./src/models/TableReport.ts